import { logger } from "src/core/globals";
import { Message } from "src/gen/schema/syncfollow/syncfollow";

import { TransportHelper } from "./core/transportHelper";
/**
 * Transport helper for JSON string format.
 */
class StringTransport extends TransportHelper<Message, string> {
  encode(msg: Message) {
    try {
      return JSON.stringify(Message.toJSON(msg));
    } catch (e: unknown) {
      logger.error(e);
    }
    return "";
  }
  decode(msg: unknown) {
    try {
      return Message.fromJSON(JSON.parse(msg as string));
    } catch (e: unknown) {
      logger.error(e);
    }
    return Message.fromPartial({});
  }
}

/**
 * Transport helper for Protocol Buffers binary format.
 */
class BinaryTransport extends TransportHelper<Message, ArrayBuffer> {
  encode(msg: Message): ArrayBuffer {
    try {
      const d = Message.encode(msg).finish();
      return d.buffer.slice(d.byteOffset, d.byteLength + d.byteOffset);
    } catch (e: unknown) {
      logger.error(e);
    }
    return new ArrayBuffer();
  }
  decode(msg: unknown) {
    try {
      return Message.decode(new Uint8Array(msg as ArrayBuffer));
    } catch (e: unknown) {
      logger.error(e);
    }
    return Message.fromPartial({});
  }
}

export { StringTransport, BinaryTransport };
